declare namespace $ {

	export class $mol_icon_skip_previous extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=previous.view.tree.d.ts.map